<template>
    <ion-header>
        <div class="el-page-header app-header">
            <h1 class="app-header-title">{{ title }}</h1>
        </div>
    </ion-header>
</template>

<script>
export default {
    name: 'AppHeader',
    props: {
        backButtonTitle: {
            type: String,
            default: 'Zurück',
        },
        title: {
            type: String,
            default: '',
        },
        backButton: {
            type: Function,
            default: () => {},
        },
    },
};
</script>
